import MultiCityForPhone from "components/MultiCityForPhone/MultiCityForPhone";
import OneWayForPhone from "components/OneWayForPhone/OneWayForPhone";
import RoundTripFormForPhone from "components/RoundTripFormForPhone/RoundTripFormForPhone";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import UserNavbar from "components/UserNavbar/UserNavbar";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import FlightSearchComponent from "../FlightSearchComponent/FlightSearchComponent";

export default function OfferDetails() {
  const [round, setRound] = useState(true);
  const [oneWay, setOneWay] = useState(false);
  const [multiCity, setMultiCity] = useState(false);
  const location = useLocation();
  const data = location?.state?.data;

  const handleCopyCoupon = () => {
    navigator.clipboard.writeText(data?.coupon?.name);
    alert("Coupon copied to clipboard!");
  };

  return (
    <section className="text-gray-800">
      <div>
        <ScrollToTopOnRouteChange />
        <UserNavbar />
      </div>
      <div className=" mx-auto my-5 max-w-8xl sm:my-10">
        <div className=" mb-10">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3 ">
            <div className="md:col-span-2">
              <div className="mx-0 overflow-hidden rounded-lg px-5 sm:mx-8 sm:px-0">
                <div
                  className="block h-96 w-full sm:hidden sm:h-96"
                  style={{
                    backgroundImage: `url(https://api.maharajaflights.com/storage/${data?.inner_image})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <img
                  className="hidden w-full sm:block"
                  src={
                    "https://api.maharajaflights.com/storage/" +
                    data?.inner_image
                  }
                  alt=""
                />
              </div>
              <div className="mx-6 sm:mx-8">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h4 className="mt-3  text-lg font-semibold capitalize text-red-500 ">
                    {data?.heading}
                  </h4>
                  <div className="my-2 flex flex-wrap gap-2 text-sm">
                    <h4 className="whitespace-nowrap border px-2 shadow-md">
                      <span className="font-bold ">Coupon Code:</span>{" "}
                      {data?.coupon?.coupon_code}
                    </h4>
                    <h4 className="border px-2 shadow-md">
                      {data?.deal?.name}
                    </h4>
                  </div>
                </div>
                <p>{data?.long_paragraph}</p>
                <p className="text-md mt-2 font-bold text-gray-900 sm:mt-5">
                  More details:{" "}
                </p>
                <p className="text-sm font-extralight ">
                  Booking Validity-Until {data?.coupon?.expiry_date}
                </p>
                <p className="text-md mt-2 font-bold text-gray-900 sm:mt-5">
                  Terms & Conditions:
                </p>
                <ul className="list-disc">
                  {data?.terms?.map((item, index) => (
                    <li key={index} className="text-sm">
                      {item.name}
                    </li>
                  ))}
                </ul>
                <button
                  className="button_bg float-right my-5 rounded-md py-2 px-4 text-white"
                  onClick={handleCopyCoupon}
                >
                  Copy coupon
                </button>
              </div>
            </div>
            <FlightSearchComponent
              round={round}
              oneWay={oneWay}
              multiCity={multiCity}
              setRound={setRound}
              setOneWay={setOneWay}
              setMultiCity={setMultiCity}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
